import tw, { styled } from "twin.macro";

export const StyledConfirmLogoutWrapper = styled.div`
  ${tw`p-ml flex flex-col `}
`;
export const StyledConfirmLogoutGrid = styled.div`
  ${tw`grid gap-m`}
`;
